<template src="./leftComponent.template.html"></template>

<script>
    // const socket = require('socket.io');


    export default {

        name: 'left',
        props: [],
        data() {
            return {
                leftPreview: null,
                showLeftVisibility: true,
            };
        },
        methods: {

        },
        computed: {
            //   isVaildSubDomain(){
            //     let vm = this;
            //     if(vm.$store.state.isValidDomainOrNot == true){
            //       return true;
            //     }
            //     return false;
            //   }
            // beCssObj() {
            //             if (this.$store.state.FooterStyle)
            //                 return this.$store.state.FooterStyle;
            //             return null
            //             // if (this.$store.state.cssObj) {
            //             //     var para = document.createElement("style");
            //             //     para.innerText = this.$store.state.cssObj;
            //             //     //console.log("para.innerText", para.innerText);
            //             //     var body = document.getElementById("BETemplateBody");
            //             //     body.appendChild(para);
            //             // }
            //         }

            leftSection() {
                if (this.$store.state.beData.LeftViewText)
                    return this.$store.state.beData.LeftViewText;
                return null
            },
            leftpanelvisible() {
                if (this.$store.state.beData.LeftPanelVisibility)
                    return true;

                return false;

            },

        },
        created() {
        },
        watch: {
            // beCssObj() {
            //           //console.log(this.beCssObj);
            //           if (this.beCssObj) {
            //               var para = document.createElement("style");
            //               para.innerText = this.beCssObj;
            //               //console.log("para.innerText", para.innerText);
            //               var body = document.getElementsByClassName("footer");
            //               body.appendChild(para);
            //           }
            //       }
            leftSection() {
                //console.log(this.beCssObj);
                let vm = this;
                if (this.leftSection) {
                    vm.leftPreview = `<html><head><style>${
                        vm.$store.state.beData.LeftViewCSS
                        }</style></head><body>${vm.$store.state.beData.LeftViewText}</body></html>`;
                }
            },
            // leftpanelvisible() {
            //     //console.log(this.beCssObj);
            //     let vm = this;
            //     if (vm.leftpanelvisible) {
            //         console.log("this.leftpanelvisible", vm.leftpanelvisible);
            //         if (vm.$store.state.beData.LeftPanelVisibility == true) {
            //             vm.showLeftVisibility = true;
            //         }
            //         else {
            //             vm.showLeftVisibility = false;
            //         }
            //     }
            // }
        },
        mounted() {
            // let vm = this;
            // if (vm.$store.state.beData.LeftPanelVisibility == true) {
            //     vm.showLeftVisibility = true;
            // }


        }
    }

</script>


// WEBPACK FOOTER //
// src/components/homeModule/leftComponent/leftComponent.vue